import { PeerType } from '@yandex-360/telemost-sdk/models';
import { ConnectionType } from '@yandex-video-platform/goloom-sdk';

export const CONNECTION_TYPE_TO_PEER_TYPE_MAP: { [key in ConnectionType]?: PeerType } = {
    [ConnectionType.CONNECTION_TYPE_PSTN]: PeerType.INCOMING_PHONE_CALL,
};
